'use client';
import ProductsPage from '@c/ProductsPage';
import type { BrandDocument } from '@models/brand';
import type { CategoryDocument } from '@models/category';
import type { PageSideFilters, TopFilters } from '@util/hooks/useProductsPage';
import type { Pagination } from '@util/types/paginator';
import type { ProductDocument } from 'models/product';
import type { PublicUserDocument } from 'models/user';

export interface BrandDetailPageProps {
  brand: BrandDocument;
  initialProducts: ProductDocument[];
  initialPageInfo: Pagination;
  initialTopFilters: TopFilters;
  initialSideFilters: PageSideFilters;
  categories: CategoryDocument[];
  sellers: {
    [key: string]: PublicUserDocument;
  };
}

const BrandDetailPage = ({
  brand,
  initialProducts,
  initialPageInfo,
  initialTopFilters,
  initialSideFilters,
  sellers,
}: BrandDetailPageProps) => {
  return (
    <ProductsPage
      initialProducts={initialProducts}
      initialPageInfo={initialPageInfo}
      initialTopFilters={initialTopFilters}
      initialSideFilters={initialSideFilters}
      headerBreadcrumb={{ label: brand.name, href: brand.url }}
      pageHeaderTitle={brand.name}
      pageHeaderBody={brand.description}
      brand={brand}
      pageType="brand"
      keyword={null}
      seller_id={null}
      categories={[]}
      sellers={sellers}
    />
  );
};

export default BrandDetailPage;
